import { createTheme } from 'react-data-table-component';

const RS_COLORS = {
  surface: '#141414',
  surfaceLight: '#1f1f1f',
  border: '#3a1a1a',
  accent: '#e10600',
  text: '#e8e8e8',
  textMuted: '#9ca3af',
};

export const DATA_TABLE_THEME = 'rs-dark';
createTheme(
  DATA_TABLE_THEME,
  {
    text: {
      primary: RS_COLORS.text,
      secondary: RS_COLORS.textMuted,
      disabled: '#6b7280',
    },
    background: {
      default: RS_COLORS.surface,
    },
    context: {
      background: RS_COLORS.surfaceLight,
      text: RS_COLORS.text,
    },
    divider: {
      default: RS_COLORS.border,
    },
    button: {
      default: RS_COLORS.accent,
      focus: RS_COLORS.accent,
      hover: '#ff2a20',
      disabled: '#4b5563',
    },
    selected: {
      default: 'rgba(225, 6, 0, 0.2)',
      text: RS_COLORS.text,
    },
    highlightOnHover: {
      default: RS_COLORS.surfaceLight,
      text: RS_COLORS.text,
    },
    striped: {
      default: RS_COLORS.surfaceLight,
      text: RS_COLORS.text,
    },
  },
  'dark'
);

export const dataTableCustomStyles = {
  table: {
    style: {
      backgroundColor: RS_COLORS.surface,
    },
  },
  tableWrapper: {
    style: {
      border: 'none',
      borderRadius: 0,
      overflow: 'hidden',
    },
  },
  headRow: {
    style: {
      backgroundColor: RS_COLORS.surfaceLight,
      borderBottom: `1px solid ${RS_COLORS.border}`,
      minHeight: '52px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '20px',
      paddingRight: '20px',
      fontSize: '13px',
      fontWeight: 600,
      color: RS_COLORS.textMuted,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
  },
  rows: {
    style: {
      minHeight: '56px',
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${RS_COLORS.border}`,
      },
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgba(31, 31, 31, 0.8)',
      transition: 'background-color 0.2s',
    },
  },
  cells: {
    style: {
      paddingLeft: '20px',
      paddingRight: '20px',
      fontSize: '14px',
      color: RS_COLORS.text,
    },
  },
  pagination: {
    style: {
      backgroundColor: RS_COLORS.surface,
      borderTop: `1px solid ${RS_COLORS.border}`,
      minHeight: '56px',
    },
    pageButtonsStyle: {
      color: RS_COLORS.accent,
      fill: RS_COLORS.accent,
      '&:disabled': {
        color: RS_COLORS.textMuted,
        fill: RS_COLORS.textMuted,
      },
      '&:hover:not(:disabled)': {
        backgroundColor: 'rgba(225, 6, 0, 0.12)',
      },
    },
  },
  noData: {
    style: {
      padding: '48px 24px',
      color: RS_COLORS.textMuted,
      fontSize: '15px',
    },
  },
  progress: {
    style: {
      backgroundColor: RS_COLORS.surface,
    },
  },
};
